import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { MemoryRouter, Route } from "react-router";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { cartAdd } from "../../actions/cart";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import {
  ButtonBack,
  ButtonFirst,
  ButtonLast,
  ButtonNext,
  CarouselProvider,
  DotGroup,
  ImageWithZoom,
  Slide,
  Slider,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

import { discountProducts } from "../../actions/products";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
class DailySale extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brandDetail: "",
      prevSlug: "",
      preSlugNo: "",
      products: "",
      brandInfo: "",
      storeInfo: "",
      dataPerPage: 40,
      currentPage: 1,
      show: false,
      quickView: [],
      images: [],
      quantity: 1,
    };
  }
  async componentDidMount() {
    window.scrollTo(0, 0);
    // const slug = window.location.toString().split("brand/")[1];
    // this.fetchData(slug);
    // this.setState({ prevSlug: slug });

    // if (this.state.prevSlug !== slug) {
    //   window.scrollTo(0, 0);
    this.fetchData();
    //   this.setState({ prevSlug: slug, preSlugNo: false });
    // }
  }
  async componentDidUpdate(prevProps, prevState) {
    // const slug = window.location.toString().split("brand/")[1];
    // if (prevState.prevSlug !== slug) {
    //   window.scrollTo(0, 0);
    //   this.fetchData(slug);
    //   this.setState({ prevSlug: slug, preSlugNo: false });
    // }
  }
  fetchData = async () => {
    window.scrollTo(0, 0);
    const res = await this.props.discountProducts();

    this.setState({
      products: res,
    });
  };

  _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "B" });
        }
      });
      if (a === true) {
        arr.push(item);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      this.setState({ show: false });
      toast(`Product added to wishlist`, { containerId: "B" });
    }
  };

  _addToCart = async (item) => {
    // console.log(item);

    const data = {
      item: item,
      quantity: this.state.quantity,
    };
    const cartAdd = await this.props.cartAdd(data);
    if (cartAdd) {
      this.setState({
        show: false,
        quantity: 1,
      });
      toast(`Product added in cart`, { containerId: "B" });
    }
  };
  handleClose = () => {
    this.setState({ show: false, quantity: 1 });
  };
  handleShow = () => {
    this.setState({ show: true, quantity: 1 });
  };
  _openModal = async (e, item) => {
    e.preventDefault();
    const productsArr = [];
    // item &&
    //   item.forEach(async __element => {
    //     productsArr.push(__element);
    //   });
    // console.log("product array ", item);
    await this.setState({ quickView: item });
    const images = [];
    item.images.forEach((e) => {
      images.push({
        original: e,
        thumbnail: e,
      });
    });
    this.setState({ images: images });

    this.setState({ show: true });
  };
  handleClick = (event) => {
    this.setState({
      currentPage: Number(event.page),
    });
  };
  render() {
    const { products, brandInfo, storeInfo } = this.state;

    const { quickView, currentPage, dataPerPage } = this.state;

    // Logic for displaying todos
    const indexOfLastTodo = currentPage * dataPerPage;
    const indexOfFirstTodo = indexOfLastTodo - dataPerPage;
    const currentTodos =
      products && products.slice(indexOfFirstTodo, indexOfLastTodo);

    const renderTodos =
      currentTodos &&
      currentTodos.map((item, index) => {
        return (
          <div
            key={index}
            className="col-md-3 my-3 col-sm-6 col-12 borderBottom-1"
          >
            <Link to={`/product/${item.slug}`}>
              <div className="product-cards">
                <div className="product-cards-img">
                  <div
                    style={{
                      backgroundImage: `url(${item.images[0]})`,
                      backgroundSize: "contain",
                      height: "100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  ></div>
                  {/* <img src={`${item.images[0]}`} width="100%" alt="" /> */}
                </div>
                <div className="card-inner-area">
                  <span className="sale-sticker">Sale</span>
                  <span
                    className="sale-wish"
                    onClick={(e) => {
                      e.preventDefault();
                      this._addToWishlist(item && item);
                    }}
                  >
                    <i className="far fa-heart" />
                  </span>
                  <div className="quick-view-btn">
                    <a href="" onClick={(e) => this._openModal(e, item)}>
                      <span>Quickview</span>
                    </a>
                  </div>
                </div>
                <div className="product-cards-content">
                  <div className="product-cards-txt">
                    <div className="row">
                      {item.grouping &&
                        item.grouping.length > 0 &&
                        item.grouping.slice(0, 5).map((group, indx) => (
                          <div
                            className="col-md-2 col-sm-2 col-2"
                            style={{
                              flex: "0 0 14.666667%",
                              maxWidth: "14.666667%",
                            }}
                            key={indx}
                          >
                            <Link
                              to={`/product/${group.slug}`}
                              style={{
                                border: "1px solid #e1e1e1",
                                borderRadius: "7px",
                                marginTop: "4px",
                              }}
                            >
                              <div
                                style={{
                                  backgroundImage: `url(${
                                    group && group.images && group.images[0]
                                  })`,
                                  backgroundSize: "contain",
                                  height: "30px",
                                  backgroundRepeat: "no-repeat",
                                  backgroundPosition: "center",
                                  width: "100%",
                                  padding: "2px",
                                }}
                              ></div>
                              {/* <img
                                src={group && group.images[0]}
                                alt={group && group.title}
                                style={{
                                  border: "1px solid gray",
                                  borderRadius: "7px",
                                  width: "100%",
                                  marginTop: "4px",
                                }}
                              /> */}
                            </Link>
                          </div>
                        ))}
                      {item.grouping && item.grouping.length > 4 && (
                        <div className="col-md-2 col-sm-2 col-2">
                          <Link
                            to={`/product/${item.slug}`}
                            className="grouping-left"
                          >
                            <div
                              style={{
                                height: "30px",
                                width: "100%",
                                border: "1px solid #e1e1e1",
                                borderRadius: "7px",
                                marginTop: "4px",
                                paddingTop: "2px",
                                textAlign: "center",
                                background: "#ecedef",
                              }}
                            >
                              {item.grouping.length - 4}+
                            </div>
                          </Link>
                        </div>
                      )}
                    </div>
                    <a
                      href=""
                      onClick={() => {
                        this.props.history.push(`/product/${item.slug}`);
                      }}
                    >
                      {item && item.title}
                    </a>
                    <div className="product-cards-price">
                      <span>
                        $
                        {item.enableSale === true
                          ? Number(
                              item.price -
                                (item.price * item.saleDiscount) / 100
                            ).toFixed(2)
                          : Number(item.price).toFixed(2)}
                      </span>
                      <span>
                        {item.enableSale === true ? (
                          <del>${Number(item.price).toFixed(2)}</del>
                        ) : null}
                      </span>
                    </div>
                    <div className="product-cards-rating">
                      <ul className="product-rating">
                        <li>
                          <i className="fa fa-star" />
                        </li>
                        <li>
                          <i className="fa fa-star" />
                        </li>
                        <li>
                          <i className="fa fa-star" />
                        </li>
                        <li>
                          <i className="fa fa-star" />
                        </li>
                        <li>
                          <i className="far fa-star" />
                        </li>
                        <span>{Math.floor(Math.random() * 150 + 1)}</span>
                      </ul>
                      <span>
                        {item.price > 49 ? <b>Free Shipping</b> : <b></b>}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      });

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(products && products.length / dataPerPage);
      i++
    ) {
      pageNumbers.push(i);
    }

    // const renderPageNumbers = pageNumbers.map((number) => {
    //   return (
    //     <ul style={{ display: "inline-block" }}>
    //       <li
    //         className={number === this.state.currentPage ? "active" : ""}
    //         key={number}
    //         id={number}
    //         style={{ listStyle: "none" }}
    //       >
    //         {/* {number === this.state.currentPage ? ( */}
    //         <button
    //           id={number}
    //           className="btn btn-primary pagi-button"
    //           onClick={this.handleClick}
    //         >
    //           {number}
    //         </button>
    //       </li>
    //     </ul>
    //   );
    // });

    return (
      <Fragment>
        <div className="wrapper-90 max-1600">
          <BreadCrumb title={`Sale / ${storeInfo && storeInfo.storeName}`} />
        </div>
        <div className="sale-page-wrapper">
          {/* SLIDE 1 */}
          <div className="wrapper-90 max-1600">
            <div
              className="container-fluid py-3"
              id="categorie-Appliance-slider"
              style={{ backgroundColor: "#f4f4f5" }}
            >
              <div className="row">
                <h4 className="sale-row-heading">Top Picks For You</h4>
                <div className="col-md-12">
                  <div className="categoriesslider">
                    <div className="swiper-container" id="slide1">
                      <div className="swiper-wrapper">
                        {currentTodos &&
                          currentTodos.map((item, index) => (
                            <div key={index} className="swiper-slide">
                              <Link
                                to={`/product/${item.slug}`}
                                className="sale-card"
                              >
                                <div className="sale-card-body">
                                  <div className="sale-card-img">
                                    <img
                                      src={item.images && item.images[0]}
                                      with="auto"
                                      alt=""
                                    />
                                  </div>
                                  <div className="sale-img-label">
                                    <span>Sale</span>
                                  </div>
                                  <div className="sale-card-footer">
                                    <h3>{item && item.title}</h3>
                                    <p>
                                      <i className="fa fa-clock" />
                                      &nbsp;
                                      <Moment toNow ago interval={0}>
                                        {item && item.salteEndDate}
                                      </Moment>
                                      <br />
                                      <span id="endDays">
                                        {" "}
                                        {moment(item.salteEndDate).format(
                                          "LLLL"
                                        )}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*END SLIDE 1 */}

            {/* ALL SALES MARKUP */}
            <div className="all-sales-container">
              <div className="container-fluid px-0">
                <div className="row row align-center">
                  <div className="col-md-6 col-sm-6  px-0">
                    <Link to="#" className="d-block m-3">
                      <div className="close-deal-content">
                        <div className="close-deal-heading">
                          <h3>Close Out Deals</h3>
                          <p>
                            Discover By the best deal on Sundial (and save up to
                            80% while you are at it).
                          </p>
                          <button className="deal-shop-btn">
                            <span>Shop Now</span>
                          </button>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-6 col-sm-6 py-md-0 py-4 px-0">
                    <Link to="#" className="d-block m-3">
                      <div className="open-box-content">
                        <div className="open-box-heading">
                          <h3>Open Box Deals</h3>
                          <p>
                            Discover By the best deal on Sundial (and save up to
                            80% while you are at it).
                          </p>
                          <button className="deal-shop-btn">
                            <span>Shop Now</span>
                          </button>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/*//END  ALL SALES MARKUp */}
            {/* FEATURED SALES */}
            {/* END FEATURED SALES */}
            <div className="allSales-grid-container">
              <div className="grid-column-container">
                {currentTodos &&
                  currentTodos.map((item, index) => (
                    <div key={index} className="grid-column">
                      <div className="sale-card-body">
                        <div className="sale-card-img">
                          <img
                            src={item.images && item.images[0]}
                            width="100%"
                            with="auto"
                            alt=""
                          />
                        </div>
                        <div className="sale-img-label">
                          <span>Sale</span>
                        </div>
                        <div className="sale-card-footer">
                          <Link to={`/product/${item.slug}`}>
                            <h3>{item && item.title}</h3>
                            <p>
                              <i className="fa fa-clock" />
                              &nbsp;
                              <Moment toNow ago interval={0}>
                                {item && item.salteEndDate}
                              </Moment>
                              <br />
                              <span id="endDays">
                                {" "}
                                {moment(item.salteEndDate).format("LLLL")}
                              </span>
                            </p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="container-fluid my-5 px-0">
              <div className="row">
                <div className="col-md-12 px-0">
                  <Link to="#" className="d-block">
                    <div className="close-deal-content">
                      <div className="close-deal-heading">
                        <h3>Close Out Deals</h3>
                        <p>
                          Discover By the best deal on Sundial (and save up to
                          80% while you are at it).
                        </p>
                        <button className="deal-shop-btn">
                          <span>Shop Now</span>
                        </button>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

discountProducts.prototype = {
  discountProducts: PropTypes.func.isRequired,
};
cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});
export default connect(mapStateToProps, {
  discountProducts,
  cartAdd,
})(DailySale);
